import { render, staticRenderFns } from "./TransporterView.vue?vue&type=template&id=028a293c&scoped=true"
import script from "./TransporterView.vue?vue&type=script&lang=js"
export * from "./TransporterView.vue?vue&type=script&lang=js"
import style0 from "./TransporterView.vue?vue&type=style&index=0&id=028a293c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028a293c",
  null
  
)

export default component.exports